var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55273 11.3354H8.71942M5.55273 7.79541H11.8861",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92773 15.5833H8.7194",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9461 15.5833C5.01857 15.5656 4.38523 15.5125 3.77169 15.3532C2.941 15.1585 2.33469 14.5036 2.15669 13.5832C1.93107 12.7159 2.01023 10.5743 1.9904 8.02556C1.99204 6.04828 1.89148 4.14933 2.24773 3.06965C2.46543 2.71565 2.64356 1.42358 5.59253 1.44128C6.08732 1.42358 11.3321 1.38818 12.1634 1.45898C14.9342 1.51208 15.2113 2.78645 15.3696 3.99003C15.47 4.87501 15.4488 6.29098 15.4488 7.79542M5.55294 1.42358C5.79044 2.57406 5.77065 3.31744 6.64148 3.49444C7.01753 3.54753 7.87671 3.54612 8.79877 3.54753C9.62178 3.5488 10.4613 3.55545 10.8373 3.47674C11.7675 3.28204 11.6686 2.25546 11.9061 1.42358",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4703 10.1849C13.3825 11.1761 11.286 12.9461 11.286 13.07C11.1169 13.28 10.9695 13.7071 10.8706 14.3089C10.7464 14.8668 10.5977 15.3532 10.7717 15.4948C10.9458 15.6364 11.6013 15.517 12.2947 15.3886C12.8484 15.3355 13.3627 15.1585 13.6198 14.9815C13.9957 14.684 16.547 12.3797 16.8438 12.0788C17.0613 11.8133 17.0811 11.3177 16.8912 11.0168C16.7844 10.8044 16.1119 10.238 15.8944 10.0787C15.4988 9.8663 14.945 9.83088 14.4703 10.1849Z",
    stroke: "#595959",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskEdit);
export default __webpack_public_path__ + "static/media/task-edit.9b3c43e8590e2b36763be08b7a14eef0.svg";
export { ForwardRef as ReactComponent };